"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const React = require("react");
const clsx = require("../../../chunks/clsx-CBkIpawf.js");
const foundations_icons_Icon = require("../../../foundations/icons/Icon.js");
const foundations_typography_Text_Text = require("../../../foundations/typography/Text/Text.js");
const Badge_module = require("../../../chunks/Badge.module-qXTkEAZZ.js");
const useButton = require("../../../chunks/useButton-DZQcT99f.js");
const BadgeButton = React.forwardRef(
  ({ children, onPress, isDismissable, isSelected, ...props }, ref) => {
    const buttonRef = React.useRef(null);
    const { buttonProps, isPressed } = useButton.$701a24aa0da5b062$export$ea18c227d4417cc3({ onPress, preventFocusOnPress: true }, buttonRef);
    return /* @__PURE__ */ jsxRuntime.jsx(
      "button",
      {
        ref,
        className: clsx.clsx(Badge_module.styles.badge, {
          [Badge_module.styles.badgeIsPressed]: isPressed,
          [Badge_module.styles.badgeIsDismissible]: isDismissable,
          [Badge_module.styles.badgeIsSelected]: isSelected
        }),
        ...buttonProps,
        ...props,
        children: /* @__PURE__ */ jsxRuntime.jsxs(foundations_typography_Text_Text.Text, { component: "span", variant: "text-body-head", className: Badge_module.styles.badgeText, children: [
          children,
          isDismissable ? /* @__PURE__ */ jsxRuntime.jsx(foundations_icons_Icon.Icon, { variant: "XSmall", "aria-hidden": true }) : null
        ] })
      }
    );
  }
);
exports.BadgeButton = BadgeButton;
